'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M177.5 282.9c31.8-143.1 90.8-211.1 150.3-242.2 56.9-29.7 117.5-27.5 163.1-19.6 7.9 45.6 10.1 106.2-19.6 163.1-31.1 59.5-99 118.5-242.2 150.3l-51.7-51.7zM504.6 7.4C430.1-7.5 301.6-13.4 218.1 128l-122.1 0-86.4 144-9.6 16 160 0 64 64 0 160 16-9.6 144-86.4 0-122.1C525.4 210.4 519.5 81.9 504.6 7.4zM163.5 272l-135.3 0 76.8-128 104.2 0c-18.1 34.4-33.7 76.5-45.7 128zM240 483.7l0-135.3c51.5-12 93.6-27.6 128-45.7l0 104.2-128 76.8zM352 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM141.1 462.3c-18.6 18.6-51.7 27.6-83.5 31.4-15.4 1.8-29.5 2.3-39.8 2.3l-1.8 0 0-1.8c0-10.3 .5-24.4 2.3-39.8 3.8-31.8 12.9-65 31.4-83.5 25.2-25.2 66.1-25.2 91.3 0s25.2 66.1 0 91.3zm11.3 11.3c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-45.3 45.3-38 152-38 152s106.7 7.3 152-38z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;